import templateUrl from 'emun.salesrep/inside-sales-container-full.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query'

class InsideSalesContainerController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    let options = {
      url: 'QueryUsers.json?SalesRepId=Inside Sales',
      pageSize: 15,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: 'FullName',
      autoLoad: true,
      append: false,
      sortOptions: {
        'Id': 'Id: Low to High',
        '-Id': 'Id: High to Low',
        'FullName': 'FullName: A to Z',
        '-FullName': 'FullName: Z to A',
        'Email': 'Email: A to Z',
        '-Email': 'Email: Z to A',
        'State': 'State: A to Z',
        '-State': 'State: Z to A',
        'Zip': 'Zip: 1 to 9',
        '-Zip': 'Zip: 9 to 1'
      }
    };
    $ctrl.query = new AutoQuery(options);
  }
  load() {
    return this.query.load.apply(this.query, arguments);
  }
  viewRep(rep) {
    console.info("WRID: ", rep.userName);
    this.$state.transitionTo("inside-sales-dashboard", { writingRepId: rep.userName});
  }
}

let InsideSalesContainer = {
  controller: InsideSalesContainerController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
}

export default InsideSalesContainer